import { render, staticRenderFns } from "./Sports.vue?vue&type=template&id=37f3800f&scoped=true"
import script from "./Sports.vue?vue&type=script&setup=true&lang=js"
export * from "./Sports.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Sports.vue?vue&type=style&index=0&id=37f3800f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f3800f",
  null
  
)

export default component.exports